import { User } from "@auth0/auth0-react";
import { AppStateCreator } from "../types";
import { AuthSlice } from "../types";
import { initialState } from ".";

export const createAuthSlice: AppStateCreator<AuthSlice> = (set) => ({
  auth: {
    profile: initialState.auth.profile,
    setProfile: (data: User | null) => {
      set((state) => ({
        auth: {
          ...state.auth, 
          profile: data
        }
      }))
    }
  }
});
